import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../stores/types';
import { ICredentialsStore } from './integration-store';

export interface IReveniCredentials {
    apiKey: string,
    storeUuid: string,
};

class ReveniCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IReveniCredentials = {} as IReveniCredentials;

	constructor() {
		makeAutoObservable(this);
	}

    public get apiKey() { return this._changes.apiKey; }
    public get storeUuid() { return this._changes.storeUuid; }

    public set apiKey(v: string) { this._changes.apiKey = v; }
    public set storeUuid(v: string) { this._changes.storeUuid = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IReveniCredentials;
    }

    public getUpdatedModel(): IReveniCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default ReveniCredentialsStore;